import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { ReactComponent as Refresh } from '@assets/Icon_Refresh.svg';


const Card = styled(
    ({ children, className }) => {

        return <div
            className={`card ${className}`}
        >
            <div className="content">
                {children}
            </div>
        </div>
    })`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 0.6em 0;
	letter-spacing: 0.016rem;
	
	>*{
		margin: 0;
		line-height: 1.2em;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	>.info{
		font-size: var(--font-size-large);
		color: var(--color-white, white);
		margin-top: 0.6em;

	}
	`




Card.Jumbo = styled(
    props => <Card {...props} />
)`
    flex-direction: row;
    
    >.headline{
        font-size: 32px;
        font-weight: 700;
        line-height: 40px;
        color: var(--color-white, white);
        flex-direction: column;
    }

    >.content {
        text-align: right;
    }

    .info{
        font-size: 32px;
        font-weight: 700;
        line-height: 40px;
        color: var(--color-white, white);
        margin-right: 1rem;
        margin-top: 4px;
    }
    
    .title {
        font-size: 14px;
    }

    div {
        flex-grow: 1;
    }

    

`


export default Card